"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var close = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 1000 1000", fill: "currentColor", width: size || '1em', height: size || '1em' }, props),
        React.createElement("path", { fill: "currentColor", d: "M921 0L500 421 79 0 0 79l421 421L0 921l79 79 421-421 421 421 79-79-421-421 421-421-79-79z" })));
};
close.displayName = 'close';
exports.default = close;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=close.js.map